import React from 'react';
import { useSelector } from 'react-redux';

const Loader = () => {
    const loading = useSelector((state) => state?.loader?.isLoading);

    if (!loading) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "3px",
                zIndex: 99999,
                overflow: "hidden",
                backgroundColor: "rgba(24, 144, 255, 0.15)",
                pointerEvents: "none",
            }}
        >
            <div
                style={{
                    width: "40%",
                    height: "100%",
                    backgroundColor: "#1890ff",
                    borderRadius: "0 2px 2px 0",
                    animation: "loaderSlide 1.2s ease-in-out infinite",
                }}
            />
            <style>{`
                @keyframes loaderSlide {
                    0% { transform: translateX(-100%); }
                    50% { transform: translateX(150%); }
                    100% { transform: translateX(350%); }
                }
            `}</style>
        </div>
    );
};

export default Loader;
